import type { IPlan } from '~/modules/pricing/types';

import { usePricingPlanData, usePricingStore, useSubscriptionStore } from '~/modules/pricing';
import { IPlanKey } from '~/modules/pricing/types';

export interface IPricingPlanPaidActive {
  isLoading: boolean;
  paidPlan?: IPlan;
  /**
   * @returns IPlanKey.CONTENT_TESTING | IPlanKey.FUNNEL_OPT | IPlanKey.PAGE_OPT | IPlanKey.PROFIT_OPT
   */
  paidPlanKey?: IPlanKey;
  paidPlanName?: string;
  /**
   * @deprecated
   */
  isPaidContentTesting: boolean;
  isPaidFunnelOpt: boolean;
  isPaidPageOpt: boolean;
  isPaidProfitOpt: boolean;
  isPaid: boolean;
}

export const usePricingPlanPaidActive = (): IPricingPlanPaidActive => {
  const { getPlanNameByPlanKey, getPlanDataByPlanId } = usePricingPlanData();

  const shopPlatformPlanActive = usePricingStore((state) => state.shopPlatformPlanActive);
  const subscriptionActive = useSubscriptionStore((state) => state.subscriptionActive);

  const isFetchedShopPlatformPlanActive = usePricingStore(
    (state) => state.isFetchedShopPlatformPlanActive,
  );

  const paidPlan = getPaidPlan();
  const paidPlanKey = getPaidPlanKey(paidPlan);
  const paidPlanName = getPlanNameByPlanKey(paidPlanKey) || '';

  const isPaid = !!paidPlan;
  const isPaidContentTesting = isPaid && paidPlanKey === IPlanKey.CONTENT_TESTING;
  const isPaidFunnelOpt = isPaid && paidPlanKey === IPlanKey.FUNNEL_OPT;
  const isPaidPageOpt = isPaid && paidPlanKey === IPlanKey.PAGE_OPT;
  const isPaidProfitOpt = isPaid && paidPlanKey === IPlanKey.PROFIT_OPT;

  return {
    isPaid,
    paidPlan,
    paidPlanKey,
    paidPlanName,
    isPaidFunnelOpt,
    isPaidPageOpt,
    isPaidProfitOpt,
    isPaidContentTesting,
    isLoading: !isFetchedShopPlatformPlanActive,
  };

  function getPaidPlan(): IPlan | undefined {
    const planActive = shopPlatformPlanActive?.plan;
    if (!planActive) return;

    if (!planActive.isTrial) return planActive;

    if (!subscriptionActive?.planID) return;

    const planBySubscription = getPlanDataByPlanId(subscriptionActive.planID);
    if (!planBySubscription || planBySubscription?.isTrial) return;

    return planBySubscription;
  }

  function getPaidPlanKey(plan?: IPlan): IPlanKey | undefined {
    if (!plan) return;
    if (plan.planKey === IPlanKey.CONTENT_TESTING) return IPlanKey.PAGE_OPT;
    return plan.planKey;
  }
};
